<mat-drawer-container>
    <mat-drawer #drawer position="end">
        <app-table-config-form [columns]="TableColumnsSorted$ | async" [selectedColumns]="displayedColumns$ | async" (selectedColumnsChange)="selectedColumnsChange($event)"></app-table-config-form>
    </mat-drawer>
    <div class="paginator-wrapper">
        <div class="grow">
            <app-dave-list
                [ColumnConfig]="TableColumns$ | async"
                [Columns]="displayedColumns$ | async"
                (ColumnsChange)="selectedColumnsChange($event)"
                [ColumnsSmall]="displayedColumns$ | async"
                [DataSource$]="DataSource$"
                [Headline]="cls.getMultiple$('Commission') | async"
                [HeadlineIcon]="CommissionIcon"
                [NewEntryToolTip]="(cls.getSingle$('Commission') | async) + ' Hinzufügen'"
                [EmptyText]="'Keine ' + (cls.getMultiple$('Commission') | async) + ' Vorhanden'"
                [MultiselectButtons]="MultiselectButtons$ | async"
                [FilterValues]="FilterValues$ | async"
                (FilterValuesChange)="FilterValues$.next($event)"
                [FilterSettings]="FilterSettings$ | async"
                [FilterCount]="FilterAmount$ | async"
                [DefaultSortDirection]="DefaultSortDirection"
                [DefaultSortActive]="DefaultSortActive"
                [preventSort]="true"
                [preventSearch]="true"
                (SortChange)="onSortChange($event)"
                (SearchChange)="onSearchChange($event)"
                [CustomCellTemplates]="customCellTemplates$ | async"
                #list
            >
                <!-- Mehrfachauswahl Status ändern -->
                <ng-container headerSectionMultiselect>
                    <app-detail-list-template
                        *ngIf="ShowStatus && list.MultiselectedEntryIds?.length"
                        [Inline]="true"
                        [Editing]="true"
                        [Data]="StatusData$ | async"
                        style="margin: 0.5rem; height: 110%"
                    ></app-detail-list-template>
                    <div>
                        <button class="header-button" [Disabled]="!list.MultiselectedEntryIds?.length" app-round-button Inverted matTooltip="Status ändern" (click)="ShowStatus = !ShowStatus" [IsLoading]="LS.IsLoading$ | async">
                            <fa-icon [icon]="ShowStatus && list.MultiselectedEntryIds?.length ? 'chevron-right' : 'info'"></fa-icon>
                        </button>
                    </div>
                </ng-container>
                <ng-container *appDetailViewButtons>
                    <button class="header-button" app-round-button Inverted matTooltip="Demo - Berechnung" (click)="OpenDemo()" *ngIf="AkkordDemoButton">
                        <fa-icon icon="euro-sign"></fa-icon>
                    </button>
                    <!--            todo: D277-5642 reparieren und button einkommentieren -->
                    <!--            <button-->
                    <!--                class="header-button"-->
                    <!--                app-round-button-->
                    <!--                Inverted-->
                    <!--                *ngIf="CommissionExportButton"-->
                    <!--                [matTooltip]="(cls.getMultiple$('Commission') | async) + ' als CSV exportieren'"-->
                    <!--                matTooltipPosition="right"-->
                    <!--                (click)="OpenCommissionCsvExportDialog()"-->
                    <!--            >-->
                    <!--                <app-double-icon Icon="file-csv" Icon2="download"></app-double-icon>-->
                    <!--            </button>-->
                    <!--<button class="header-button" app-round-button Inverted *ngIf="CommissionExportButton" [matTooltip]="(cls.getMultiple$('Commission') | async) + ' als CSV Exportieren'" matTooltipPosition="right" (click)="CsvDownload()">
                        <app-double-icon Icon="file-contract" Icon2="download"></app-double-icon>
                    </button>
                -->
                    <button class="header-button2" app-round-button Inverted [matBadge]="disabledColumns$ | async" matTooltip="Tabelle anpassen" (click)="drawer.toggle()">
                        <fa-icon icon="cog"></fa-icon>
                    </button>
                    <button
                        class="header-button"
                        app-round-button
                        Inverted
                        *ngIf="NewCommissionButton"
                        [matTooltip]="(cls.getSingle$('Commission') | async) + ' hinzufügen'"
                        matTooltipPosition="right"
                        (click)="CreateCommission()"
                        [Disabled]="!(PS.Has$(PS.Permissions.CreateCommission) | async) || LS.isLoading"
                    >
                        <app-double-icon Icon="file-contract" Icon2="plus"></app-double-icon>
                    </button>
                </ng-container>
            </app-dave-list>
        </div>
        <mat-paginator [class.limit-reached]="true" [pageSize]="200" [pageSizeOptions]="[25, 50, 100, 200]" [length]="length$ | async"></mat-paginator>
    </div>
</mat-drawer-container>
<ng-template #lastCommentCell let-rowData>
    <div class="cell-flex-wrapper" [style.height]="list.itemSize + 'px'">
        <button matTooltip="Kommentare schreiben" (click)="onCommentClick(rowData.id); $event.stopPropagation()" app-round-button><fa-icon [icon]="CommentIcon"></fa-icon></button>
        <app-loading [Size]="24" *ngIf="!(commentsFetched$ | async)"></app-loading>
        <div *ngIf="rowData.lastComment$ | async as html"  style="display: flex; flex-direction: column; height: 100%">
            <div [innerHtml]="html" class="comment-line"></div>
        </div>
    </div>
</ng-template>
<ng-template #offerSumCell let-rowData>
    <ng-container *ngIf="canGetLedgerImports$ | async; else noOfferSum">
        <ng-container *ngIf="rowData.offerSum$ | async as dataOfferSum; else offerSumLoading">
            <app-loading [Size]="24" *ngIf="dataOfferSum === null"></app-loading>
            <span>{{ dataOfferSum }}</span>
        </ng-container>
    </ng-container>
    <ng-template #offerSumLoading>
        <app-loading [Size]="24"></app-loading>
    </ng-template>
    <ng-template #noOfferSum>-</ng-template>
</ng-template>
<ng-template #roleCell let-rowData let-columnName="columnName">
    <div class="cell-flex-wrapper" [style.height]="list.itemSize + 'px'">
        <button (click)="OpenUserSelect(rowData.id); $event.stopPropagation()" app-round-button><fa-icon icon="user-cog"></fa-icon></button>
        <div class="three-line">{{rowData.roleCols[columnName]}}</div>
    </div>
</ng-template>

<ng-template #hasChildCell let-rowData let-columnName="columnName">
    <div class="flex flex-col" [style.height]="list.itemSize + 'px'">
        <div class="cell-flex-wrapper" >
            <div class="one-line">{{rowData[columnName]}}</div>
        </div>
        <mat-basic-chip class="parent-commission-chip" *ngIf="rowData.isParentCommission" [matTooltip]="rowData.isParentCommissionTooltip" [disableRipple]="true" [selectable]="false" style="margin-right: auto">
            <fa-icon matChipAvatar [icon]="CommissionIcon"></fa-icon>
            {{cls.getMultiple$('Commission') | async}}
        </mat-basic-chip>
    </div>
</ng-template>
